import _ from 'lodash';
import Collection from '@skyjs/collection';

export default function makeGetAggregate(invokeFunction) {
  let _requests = new Collection();

  const fetch = _.debounce(async () => {
    const requests = _requests;
    _requests = new Collection();
    try {
      const queries = requests.map('query').uniqBy('id');
      const res = await invokeFunction('data-get', { queries });
      requests.forEach(req => {
        const data = _.find(res.data, { id: req.query.id });
        req.resolve(data);
      });
    } catch (err) {
      requests.forEach(req => {
        req.reject(err);
      });
    }
  }, 10);

  return function getAggregate(id, version, options) {
    return new Promise((resolve, reject) => {
      _requests.push({
        resolve,
        reject,
        query: _.omitBy({ id, version, queryOptions: options }, _.isNil)
      });
      fetch();
    });
  };
}
